// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersModal_wrapper__3CZnq","inputWrapper":"UsersModal_inputWrapper__37AOP","button":"UsersModal_button__Yn0l8"};